import { render } from "./ComponenteDisponibilidadCogeneracion.vue?vue&type=template&id=0132041b&scoped=true"
import script from "./ComponenteDisponibilidadCogeneracion.vue?vue&type=script&lang=js"
export * from "./ComponenteDisponibilidadCogeneracion.vue?vue&type=script&lang=js"

import "./ComponenteDisponibilidadCogeneracion.vue?vue&type=style&index=0&id=0132041b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0132041b"]])

export default __exports__